// extracted by mini-css-extract-plugin
export var fullHeightState = "_1j-7";
export var headerCell = "_1j-1";
export var loadingStateCell = "_1j-4";
export var rowWrapper = "_1j-3";
export var standaloneTable = "_1j-8";
export var standaloneTableWithBodyFill = "_1j-9";
export var stateCell = "_1j-5";
export var table = "_1j-0";
export var tableBodyFiller = "_1j-6";
export var white = "_1j-2";